import {
	getDevDocsProperties,
	getDevDocsSmartFolderProperties,
	type DevDocsContentPropertyNode,
	type DevDocsProperties,
	type SmartFolderProperties,
} from './DevDocsProperties.ts';

export type DevDocsFolderMetadata = {
	readonly containerApp: string | null;
	readonly devDocsProperties: DevDocsProperties | null;
	readonly smartFolderProperties: SmartFolderProperties | null;
};

export const getDevDocsFolderMetadata = (
	properties?: readonly DevDocsContentPropertyNode[] | null,
): DevDocsFolderMetadata => {
	const devDocsProperties = getDevDocsProperties(properties);
	const smartFolderProperties = getDevDocsSmartFolderProperties(properties);

	return {
		containerApp: smartFolderProperties?.containerApp ?? null,
		devDocsProperties,
		smartFolderProperties,
	};
};
